import { Component } from "@angular/core";
import { FormControl, Validators, FormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import { conformToMask } from "text-mask-core";
import { ValidatorService } from "../../services/validator.service";
import { DateTime } from "luxon";

@Component({
  selector: "app-renda-variavel",
  templateUrl: "./renda-variavel.component.html",
  styleUrls: ["./renda-variavel.component.scss"],
})
export class BoletaRendaVariavelComponent {
  typeAction: any;
  operationMode: any;

  constructor(public validator: ValidatorService) {}

  validators = {
    portfolioDocument: (value) => this.validator.validateDocument(value),
    resourceDate: (value) =>
      this.coalesce(value).length === 0 ||
      DateTime.fromFormat(value, "dd/MM/yyyy").isValid,
    dueDate: (value) =>
      this.coalesce(value).length === 0 ||
      DateTime.fromFormat(value, "dd/MM/yyyy").isValid,
    settlementSaleDate: (value) =>
      this.coalesce(value).length === 0 ||
      DateTime.fromFormat(value, "dd/MM/yyyy").isValid,
    settlementDate: (value) =>
      this.coalesce(value).length === 0 ||
      DateTime.fromFormat(value, "dd/MM/yyyy").isValid,
    radingDate: (value) =>
      this.coalesce(value).length === 0 ||
      DateTime.fromFormat(value, "dd/MM/yyyy").isValid,
  };

  coalesce(value: any) {
    return value || "";
  }
}
